export enum ContactsTabs {
  CONTACTS = "contacts",
  CONTACTS_GROUPS = "contact-groups",
  CONTACTS_FILTERS = "contact-filters",
}

export enum AccountManagementTabs {
  CREDITS = "credits",
  CREDITS_USAGE = "credits-usage",
  USER_ACCOUNTS = "user-accounts",
  GROUP_ACCESS = "group-access",
  MSISDN_ACCESS = "msisdn-access",
  PROFANITY_FILTER = "profanity-filter",
  CONTACT_FOLDER = "contact-folder",
  TEMPLATES_ACCESS = "templates-access",
  WEBHOOKS = "web-hooks",
  TAGS = "tags",
  QUICK_SEND = "quick-send",
}

export enum SettingsTabs {
  USER_PROFILE = "user-profile",
  SECURITY = "security",
  CONTACTS = "contacts",
  MESSAGE_FORWARDING = "message-forwarding",
  TAGS = "tags",
  AUTO_REPLY = "auto-reply",
}

export enum CreditsTabs {
  PURCHASE_CREDITS = "purchase-credits",
  TOPUP_CREDITS = "topups-credits",
  LOW_CREDITS_ALERT = "low-credits-alert",
}

export enum AppManagementTabs {
  APP_IDS = "responder-accounts",
  STATUS_PROFILES = "status-profiles",
  PRIORITY_PREFIX = "priority-prefix",
}
